import React from "react";
import { Link } from "react-router-dom";
import { loginRequest } from "../settings";
import { isInIframe } from "./iframe";
import { useMsal } from "@azure/msal-react";
import { devLog } from "../utils/devLog";

/**
 * Home — unauthenticated landing page.
 *
 * Displays the animated welcome screen and a Sign In button.
 * Uses loginPopup inside iframes and loginRedirect otherwise to avoid
 * breaking parent-frame navigation during the auth flow.
 */
function Home() {
  const { instance } = useMsal();

  const login = async () => {
    if (isInIframe()) {
      devLog("Inside Login If : ", isInIframe());
      await instance.loginPopup(loginRequest);
    } else {
      devLog("Inside Login Else : ", isInIframe());
      await instance.loginRedirect(loginRequest);
    }
  };

  return (
    <section className="login-section">
      <section className="left-section">
        <div className="left-section-inner">
          <div>
            <img
              className="shakeanimation"
              src="/images/unicow.png"
              alt="Light &amp; Wonder"
              height="180"
            />
          </div>
          <div className="typing-animation-block">
            <h1>
              <span className="title">
                Welcome to <span>AI Chat</span>
              </span>
              <span className="titleshadow"></span>
            </h1>
            <h2 className="typing-animation">
              <span className="ityped">Its all about the LnW AI Chatbot</span>
            </h2>
          </div>

          <div className="bubble bubble--1"></div>
          <div className="bubble bubble--2"></div>
          <div className="bubble bubble--3"></div>
          <div className="bubble bubble--4"></div>
          <div className="bubble bubble--5"></div>
          <div className="bubble bubble--6"></div>
          <div className="bubble bubble--7"></div>
          <div className="bubble bubble--8"></div>
          <div className="bubble bubble--9"></div>
          <div className="bubble bubble--10"></div>
          <div className="bubble bubble--11"></div>

          <div className="boat"></div>
          <div className="fish"></div>
          <div className="fish1"></div>
          <div className="fish2"></div>
        </div>
      </section>

      <section className="right-section">
        <section className="login-container">
          <div className="logo-inner">
            <img src="/images/logo.png" alt="Light &amp; Wonder" className="logo" />
          </div>
          <div className="login-inner">
            <section id="loginSec">
              <div id="loginForm">
                <h3>AI Chat</h3>
                <Link to="/chat/peoplehub">
                  <input
                    type="button"
                    id="btnSubmit"
                    className="primary-btn mar-top20"
                    value="Sign In"
                    onClick={login}
                  />
                </Link>
              </div>
            </section>
            <div className="login-loader" id="js-loader">
              <img src="/images/lnw-loader.gif" alt="L&amp;W" />
            </div>
          </div>
          <p className="copyright-content">
            © <span id="current-year">2025</span> Light &amp; Wonder, Inc. All Rights Reserved.
          </p>
        </section>
      </section>
    </section>
  );
}

export default Home;
